import type { ReactNode } from "react";

import type { PunchupTooltipProps } from "./PunchupTooltip";

type TooltipHelpText = Pick<PunchupTooltipProps, "mainText" | "secondaryText">;

/** Help copy: a bare string is one paragraph; the object form adds a `secondaryText` second line. */
export type PunchupTooltipHelp = string | TooltipHelpText;

export const resolveTooltipHelp = (
  help: PunchupTooltipHelp
): TooltipHelpText => (typeof help === "string" ? { mainText: help } : help);

/** The accessible name of a help trigger beside `label`. */
export const helpTriggerLabel = (label: ReactNode): string =>
  typeof label === "string"
    ? `${label} — more information`
    : "More information";
